import { render, staticRenderFns } from "./AssignmentDetailsForm.vue?vue&type=template&id=ac8aacde&scoped=true&"
import script from "./AssignmentDetailsForm.vue?vue&type=script&lang=js&"
export * from "./AssignmentDetailsForm.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentDetailsForm.vue?vue&type=style&index=0&id=ac8aacde&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac8aacde",
  null
  
)

export default component.exports